import { AppState } from './../../../../App.state';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { Chart, registerables } from 'chart.js';
import { EstadosClientes } from 'src/app/base/domain/dto/estados-clientes.dto';
import { NovoDashboardService } from 'src/app/base/services/novo-dashboard.service';
import { DialogService } from 'src/app/global/services/dialog.service';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboard-estados-clientes',
  templateUrl: './dashboard-estados-clientes.component.html',
  styleUrls: ['./dashboard-estados-clientes.component.css']
})
export class DashboardEstadosClientesComponent implements OnInit {

  @ViewChild('graficoEstadosClientes', { static: true })
  canvas!: ElementRef<HTMLCanvasElement>;

  queryOptions = new QueryOptions({ pageSize: 10 });
  list: EstadosClientes[] = [];
  chart?: Chart;

  private itemVisibility: boolean[] = [];

  constructor(
    private service: NovoDashboardService,
    private appState: AppState,
    public dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.loadDashboard();
  }

  private loadDashboard(): void {
    this.appState.isLoading = true;

    this.service.findAllEstadosClientes(this.queryOptions).subscribe({
      next: (response) => {
        this.list = response;
        this.itemVisibility = new Array(this.list.length).fill(true);
        this.buildChart();
        this.appState.isLoading = false;
      },
      error: () => {
        this.dialogService.feedbackError("erro ao carregar o dashboard");
        this.appState.isLoading = false;
      }
    });
  }

  private buildChart(): void {
    if (!this.canvas || !this.list.length) return;

    const labels = this.list.map(item => item.uf);
    const valoresOriginal = this.list.map(item => item.total);
    const maxValue = Math.max(...valoresOriginal);
    const minValue = Math.min(...valoresOriginal);
    const baseColors = valoresOriginal.map(v => v === maxValue ? '#66bb6a' : v === minValue ? '#ef5350' : '#42a5f5');
    const valores = valoresOriginal.map((v, i) => this.itemVisibility[i] ? v : 0);

    if (this.chart) this.chart.destroy();

    this.chart = new Chart(this.canvas.nativeElement, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          label: 'Total Clientes por Estado',
          data: valores,
          backgroundColor: baseColors,
          borderRadius: 8
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,

        animation: {
          duration: 700,
          easing: 'easeOutQuart',
          delay: (context) => {
            if (context.type === 'data' && context.mode === 'default') {
              return context.dataIndex * 120;
            }
            return 0;
          }
        },

        plugins: {
          legend: {
            display: true,
            labels: {
              generateLabels: (chart) => {
                const data = chart.data;
                if (data.labels?.length) {
                  return data.labels.map((label, i) => ({
                    text: label as string,
                    position: 'bottom',
                    fillStyle: (data.datasets[0].backgroundColor as string[])[i],
                    hidden: !this.itemVisibility[i],
                    index: i
                  }));
                }
                return [];
              }
            },
            onClick: (_e, legendItem, legend) => {
              const index = legendItem.index;
              this.itemVisibility[index] = !this.itemVisibility[index];

              if (this.chart) {
                const newData = this.list.map((item, i) => this.itemVisibility[i] ? item.total : 0);
                this.chart.data.datasets[0].data = newData;
                this.chart.update();
              }
            }
          },
          tooltip: {
            callbacks: {
              title: (items) => labels[items[0].dataIndex],
              label: (item) => ` Total: ${item.raw}`
            }
          }
        },

        scales: {
          x: {

            ticks: {
              autoSkip: false,
              font: {
                family: 'Roboto',
                size: 12,
                weight: '600'
              },
              color: '#424242'
            },
            grid: {
              display: false
            }
          },
          y: {
            beginAtZero: true,
            ticks: {
              font: {
                family: 'Roboto',
                size: 12,
                weight: '500'
              },
              color: '#616161'
            },
            grid: {
              color: 'rgba(0,0,0,0.06)'
            }
          }
        }
      },

      plugins: [
        {
          id: 'valueLabel',
          afterDatasetsDraw: (chart) => {
            const { ctx } = chart;
            ctx.save();
            ctx.font = '700 14px Roboto';
            ctx.fillStyle = '#212121';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            ctx.shadowColor = 'rgba(0,0,0,0.25)';
            ctx.shadowBlur = 4;
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;

            chart.getDatasetMeta(0).data.forEach((bar: any, index: number) => {
              ctx.fillText(valores[index].toString(), bar.x, bar.y - 6);
            });

            ctx.restore();
          }
        }
      ],
    });
  }
}
